import CloseCircleIcon from '@/common/assets/icons/closeCircleIcon.svg?react';
import CalenderIcon from '@/common/assets/icons/dateIcon.svg?react';
import Input from '@/common/components/base/input/base/Input.tsx';
import {
  calendarInputsType,
  DateInputType,
} from '@/common/components/base/input/dateInput/DateInput.type';
import CalendarModal from '@/common/components/base/input/dateInput/modals/CalendarModal';
import useModal from '@/common/hooks/useModal';
import { useEffect, useState } from 'react';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { useController, useFormContext } from 'react-hook-form';
import { DateObject } from 'react-multi-date-picker';
import { token } from 'styled-system/tokens';

const DateInput = ({
  name,
  rules,
  label,
  onChange,
  defaultValue = '',
  modalLabel,
  buttonText,
  optionalLabel,
  className,
  minDate,
  maxDate,
  isDefaultValueEmpty = false,
}: DateInputType & {
  minDate?: Date;
  maxDate?: Date;
  isDefaultValueEmpty?: boolean;
}) => {
  const persianDate = new DateObject({ calendar: persian, locale: persian_fa });
  const [date, setDate] = useState<DateObject | null>(null);
  const [calendarInputs, setCalendarInputs] = useState<calendarInputsType>({
    dayInput: persianDate.day || '',
    monthInput: persianDate.month.number || '',
    yearInput: persianDate.year || '',
  });
  const { openModal, open, closeModal } = useModal();
  const { control, setValue } = useFormContext();
  const controller = useController({
    rules,
    control,
    name,
    defaultValue,
  });
  const { field, fieldState } = controller;
  const errorMessage = fieldState.error?.message;
  const onReset = () => {
    field.onChange('');
    onChange?.('');
  };
  useEffect(() => {
    if (!field.value && !isDefaultValueEmpty) {
      const today = new DateObject({ calendar: persian, locale: persian_fa });
      const formatted = `${today.year}/${today.month.number}/${today.day}`;
      setValue(name, formatted, { shouldValidate: true });
    }
  }, [field.value]);
  return (
    <>
      <Input
        inputProps={{
          readOnly: true,
          value: field.value,
          name,
          onClick: openModal,
          placeholder: 'روز / ماه / سال',
          className: className,
        }}
        inputRef={field.ref}
        errorMessage={errorMessage}
        label={label}
        optionalLabel={optionalLabel}
        endAttachments={[
          {
            element: field.value ? (
              <CloseCircleIcon
                width="22px"
                stroke={token('colors.black-4')}
                onClick={onReset}
              />
            ) : (
              <CalenderIcon width="22px" stroke={token('colors.black-4')} />
            ),
            shouldRender: true,
            size: 'small',
          },
        ]}
      />
      <CalendarModal
        field={field}
        onChange={onChange}
        buttonText={buttonText}
        modalLabel={modalLabel}
        open={open}
        closeModal={closeModal}
        calendarInputs={calendarInputs}
        persianDate={persianDate}
        date={date}
        setDate={setDate}
        setCalendarInputs={setCalendarInputs}
        minDate={minDate}
        maxDate={maxDate}
      />
    </>
  );
};

export default DateInput;
